// Directives
import { ReportSecuritySearchInputDirective } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/report-security-search-modal/report-security-search-input.directive';
// Components
import { SecurityAutocompleteInPlaceComponent } from 'SearchApp/ts/features/autocomplete-in-place/security-autocomplete-in-place.component';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../search/static/search/ts/features/autocomplete-in-place/security-autocomplete-in-place.component";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = (a0, a1) => ({ "draggable-security": a0, "bg-gray-base-95": a1 });
function ReportSecuritySearchInputComponent_ng_template_0_input_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 13);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", true)("readonly", true)("value", ctx_r1.reportLabelPreview);
} }
function ReportSecuritySearchInputComponent_ng_template_0_input_11_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 14);
    i0.ɵɵlistener("input", function ReportSecuritySearchInputComponent_ng_template_0_input_11_Template_input_input_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.updateCustomLabelHandler($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", ctx_r1.customLabel ?? "");
} }
function ReportSecuritySearchInputComponent_ng_template_0_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "button", 16);
    i0.ɵɵlistener("click", function ReportSecuritySearchInputComponent_ng_template_0_div_12_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView((ctx_r1.removeSecurityHandler ?? ctx_r1.stubFunc)()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 17);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1.removeSecurityHandler != null ? "" : "invisible");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-close");
} }
function ReportSecuritySearchInputComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 1)(1, "td", 2)(2, "div", 3)(3, "div", 4)(4, "div", 5)(5, "span", 6);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 7)(8, "ycn-security-autocomplete-in-place", 8);
    i0.ɵɵlistener("submitHandler", function ReportSecuritySearchInputComponent_ng_template_0_Template_ycn_security_autocomplete_in_place_submitHandler_8_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectSecurity($event)); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "div", 9);
    i0.ɵɵtemplate(10, ReportSecuritySearchInputComponent_ng_template_0_input_10_Template, 1, 3, "input", 10)(11, ReportSecuritySearchInputComponent_ng_template_0_input_11_Template, 1, 1, "input", 11)(12, ReportSecuritySearchInputComponent_ng_template_0_div_12_Template, 3, 3, "div", 12);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(16, _c0, ctx_r1.sortable, ctx_r1.errorMessage));
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(ctx_r1.sortable && ctx_r1.removeSecurityHandler != null ? "plate cursor-move" : "");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("drag-handle", ctx_r1.sortable);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r1.rowCount, ". ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("buttonType", "icon-search")("errorMessage", ctx_r1.errorMessage)("disableEditBtn", ctx_r1.disableEditBtn || ctx_r1.disableAutocompleterInput)("disableAutocompleterInput", ctx_r1.disableAutocompleterInput)("displayIdentifier", ctx_r1.displayIdentifier)("searchType", "report_securities");
    i0.ɵɵattribute("data-test-id", ctx_r1.autocompleterTestID ?? "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.namingConvention !== "custom");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.namingConvention === "custom");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showControls);
} }
/**
 * Report Security Search Input Component
 *
 * Handles searching for individual securities and displaying the preview.
 *
 * Input Properties:
 *  showControls: whether drag/drop and delete buttons are shown.
 *  sortable: whether the security should be able to be reordered.
 */
export class ReportSecuritySearchInputComponent extends ReportSecuritySearchInputDirective {
    constructor() {
        super(...arguments);
        this.showControls = false;
        this.sortable = false;
        this.stubFunc = () => { };
    }
}
ReportSecuritySearchInputComponent.ɵfac = /*@__PURE__*/ (() => { let ɵReportSecuritySearchInputComponent_BaseFactory; return function ReportSecuritySearchInputComponent_Factory(__ngFactoryType__) { return (ɵReportSecuritySearchInputComponent_BaseFactory || (ɵReportSecuritySearchInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ReportSecuritySearchInputComponent)))(__ngFactoryType__ || ReportSecuritySearchInputComponent); }; })();
ReportSecuritySearchInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReportSecuritySearchInputComponent, selectors: [["ycn-report-security-search-input"]], viewQuery: function ReportSecuritySearchInputComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(SecurityAutocompleteInPlaceComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autoCompleteInPlace = _t.first);
    } }, inputs: { showControls: "showControls", sortable: "sortable" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 0, consts: [["template", ""], [3, "ngClass"], ["colspan", "2"], [1, "border-0", "pt-4px", "pb-4px", "pl-1", "pr-1", 2, "background-color", "transparent"], [1, "row", "narrow-gutters", "align-items-baseline"], [1, "col-7", "d-flex", "align-items-baseline"], [1, "text-default", "pr-1"], [1, "form-group-editable", "flex-auto"], [1, "width-full", 3, "submitHandler", "buttonType", "errorMessage", "disableEditBtn", "disableAutocompleterInput", "displayIdentifier", "searchType"], [1, "col-5", "d-flex", "align-items-center"], ["class", "form-control", "type", "text", "ycnDisabled", "", 3, "disabled", "readonly", "value", 4, "ngIf"], ["class", "form-control", "type", "text", 3, "value", "input", 4, "ngIf"], ["class", "plate-controls pl-1", 4, "ngIf"], ["type", "text", "ycnDisabled", "", 1, "form-control", 3, "disabled", "readonly", "value"], ["type", "text", 1, "form-control", 3, "input", "value"], [1, "plate-controls", "pl-1"], ["ycnTooltip", "", "tooltipTitle", "Remove", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "plate-control", 3, "click"], ["ycnIcon", "", 3, "name"]], template: function ReportSecuritySearchInputComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ReportSecuritySearchInputComponent_ng_template_0_Template, 13, 19, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    } }, dependencies: [i1.SecurityAutocompleteInPlaceComponent, i2.NgClass, i2.NgIf, i3.DisabledDirective, i4.IconDirective, i5.TooltipDirective], encapsulation: 2 });
